/** Size values for {@link Tag}. */
export const TagSizes = {
    extraSmall: "extraSmall",
    small: "small",
    medium: "medium"
};
/** Primary text size values for {@link Tag}. */
export const TagTextSizes = {
    caption1: "caption1",
    body1: "body1"
};
/** Shape values for {@link Tag}. */
export const TagShapes = {
    rounded: "rounded",
    circular: "circular"
};
/** Appearance values for {@link Tag}. */
export const TagAppearances = {
    filled: "filled",
    outline: "outline",
    brand: "brand"
};
/** Event names for Tag. */
export const TagEventNames = {
    dismiss: "dismiss"
};
//# sourceMappingURL=tag.options.js.map